var _rect, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScankit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "url(#paint0_linear_471_15461)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9187 11.521C10.5329 11.3208 10.5329 10.7689 10.9187 10.5688L15.7544 8.06025C15.9092 7.97991 16.0935 7.97992 16.2483 8.06026L21.0834 10.5688C21.4692 10.769 21.4692 11.3208 21.0834 11.5209L16.2483 14.0295C16.0935 14.1098 15.9092 14.1098 15.7544 14.0295L10.9187 11.521ZM10.2763 17.4236C10.1058 17.329 10 17.1494 10 16.9545V12.7337C10 12.3249 10.4389 12.0664 10.7964 12.2646L15.327 14.7766C15.4975 14.8711 15.6032 15.0507 15.6032 15.2456V19.4664C15.6032 19.8752 15.1643 20.1337 14.8068 19.9355L10.2763 17.4236ZM21.2036 12.2649C21.5611 12.0666 22.0001 12.3251 22.0001 12.7339V16.9546C22.0001 17.1495 21.8944 17.329 21.724 17.4236L17.1967 19.9352C16.8392 20.1335 16.4001 19.875 16.4001 19.4662V15.2455C16.4001 15.0506 16.5059 14.8711 16.6763 14.7765L21.2036 12.2649Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33327 16.0001V16.2151C8.28677 16.7624 7.66664 17.4427 7.66664 18.1798C7.66664 19.988 11.3976 21.4538 16 21.4538C20.6024 21.4538 24.3333 19.988 24.3333 18.1798C24.3333 17.4426 23.7132 16.7624 22.6666 16.2151V16C24.7125 16.7868 26 17.9303 26 19.2029C26 21.5762 21.5229 23.5 16 23.5C10.4772 23.5 6 21.5762 6 19.2029C6 17.9303 7.28748 16.7869 9.33327 16.0001Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_471_15461",
    x1: 0.001609,
    y1: 31.9995,
    x2: 36.5789,
    y2: 25.4076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7043"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA270"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScankit);
export default __webpack_public_path__ + "static/media/Scankit.46c8995f34bef8b608a4f3ae264d61c0.svg";
export { ForwardRef as ReactComponent };